// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yocket-card-child:hover,.yocket-card-sibling:hover+.yocket-card-child{transform:scale(1.5);cursor:pointer}.yocket-card-child,.yocket-card-child:hover,.yocket-card-sibling:hover+.yocket-card-child{transition:all .5s}.yocket-card-child{background-size:cover;background-repeat:no-repeat}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
